import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    liveDowntimeReportWrapper: {
        display: "flex",
        flexDirection: "column",
        gap: 12,
        padding: "0px 22px 22px 22px",
    },
    liveDowntimeReportWrapperLoading: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "calc(100vh - 222px)",
        width: "100%",
    },
}));
